import { useState, useEffect } from 'react'
import { useDisclosure, IconButton } from '@chakra-ui/react'
import { ChevronUpIcon } from '@chakra-ui/icons'
import { Outlet } from 'react-router-dom'
import NavDrawer from './NavDrawer'
import PageHeader from './PageHeader'

function Nav() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const user = JSON.parse(localStorage.getItem('user') ?? 'null')
  return (
    <>
      <PageHeader onOpen={onOpen} />
      <NavDrawer user={user} isOpen={isOpen} onClose={onClose} />
    </>
  )
}

function ScrollToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <IconButton
      aria-label="Scroll to top"
      icon={<ChevronUpIcon boxSize={5} />}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      position="fixed"
      bottom={6}
      right={4}
      zIndex={5}
      size="sm"
      bg="whiteAlpha.200"
      backdropFilter="blur(10px)"
      border="1px solid"
      borderColor="whiteAlpha.300"
      color="white"
      _hover={{ bg: 'whiteAlpha.300', transform: 'scale(1.05)' }}
      style={{
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'opacity 0.2s',
      }}
    />
  )
}

export default function Layout() {
  return (
    <>
      <Nav />
      <Outlet />
      <ScrollToTop />
    </>
  )
}
